/**
 * Adds given parameters to URL.
 * @example
 * const url = 'https://wix.com/hello?hello=world'
 * const params = {
 *   field: 'one',
 *   array: ['two', 'three'],
 * }
 * const nextUrl = addQueryParams(url, params)
 * // => 'https://wix.com/hello?hello=world&field=one&array=two&array=three'
 */
export const addQueryParams = function (url, query, options) {
  if (options === void 0) {
    options = {
      override: true
    };
  }
  const urlInstance = new URL(url);
  Object.entries(query).filter(_ref => {
    let [key] = _ref;
    return options.override || !urlInstance.searchParams.has(key);
  }).forEach(_ref2 => {
    let [key, value] = _ref2;
    if (value !== undefined) {
      Array.isArray(value) ? value.forEach(valueItem => urlInstance.searchParams.append(key, valueItem)) : urlInstance.searchParams.set(key, value);
    }
  });
  return urlInstance.toString();
};
//# sourceMappingURL=addQueryParams.js.map